export class DocumentsNotAvailableError extends Error {
  public constructor(message?: string) {
    super(message);
  }
}
